import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {ActionAlert} from "../../../../core/dto/actionAlert";
import {FormBuilder, Validators} from "@angular/forms";
import {NzModalRef} from "ng-zorro-antd/modal";
import {ItineraryService} from "../../../../core/services/itinerary.service";
import {ItineraryTemplatesService} from "../../../../core/services/itinerary-templates.service";
import {GooglePlacesService} from "../../../../core/services/google-places.service";
import {AppUtils} from "../../../../core/config/app.utils";
import {NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs} from "ng-zorro-antd/upload";
import {UploadService} from "../../../../core/services/upload.service";
import {ExperienceDTO} from "../../../../core/dto/experiences";
import {ExperienceService} from "../../../../core/services/experience.service";
import {SETTINGS} from "../../../../core/config/common.settings";
import {NzMessageService} from "ng-zorro-antd/message";
import {amountFormatter, amountParser, currencyFormatter} from "../../../../core/ult-functions/currency-calculation";
import {SettingService} from "../../../../core/services/setting.service";
import {LanguageService} from "../../../../core/services/language.service";
import {AuthService} from "../../../../modules/auth/services/auth.service";
import {UserService} from '../../../../core/services/user.service';
import {OpenAiService} from "../../../../core/services/open-ai.service";
import {Subscription} from "rxjs";
import { take } from 'rxjs/operators';
import {appendRichText, buildRichText, stripExperienceBlocks} from "../../../../core/ult-functions/experiences";
import { ImagePositionState, DEFAULT_IMAGE_POSITION } from '../../../shared/image-positioner/image-position-state';
import { TranslocoService } from '@ngneat/transloco';
import { withItineraryLockSession } from '../../../../core/ult-functions/itinerary-tab-session';


const getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

@Component({
  selector: "app-add-edit-experiences-content",
  templateUrl: "./add-edit-experiences-content.component.html",
  styleUrls: ["./add-edit-experiences-content.component.scss"]
})
export class AddEditExperiencesContentComponent implements OnInit, OnDestroy {

  @Input() itinerary?: any;
  @Input() dateIndex?: any;
  @Input() mode?: any;
  @Input() experiencesPlaceIDOrID?: any;
  @Input() entryType?: any;
  @Input() featuredContent?: any;
  @Input() featuredNote?: any;
  @Input() country?: string;
  @Input() indexDay?: any;
  @Input() indexExperience?: any;
  @Input() itineraryMode: 'itinerary' | 'template' = 'itinerary';
  @Input() sessionId?: string;

  subscription: Subscription | undefined;
  langChangeSub?: Subscription;
  fixedPercentSymbol: any[] = [];
  conditionTypes: any[] = [];

  experiencesForm: any;
  featuredForm: any;
  formErrors: any;

  googlePlaceDetails: any | undefined;
  tempSuggestion: any;
  listOfTagOptions: any = [];
  timeOptions = [
    { value: 'AM', label: 'itineraries.experiences.form.time.am' },
    { value: 'PM', label: 'itineraries.experiences.form.time.pm' },
    { value: 'Morning', label: 'itineraries.experiences.form.time.morning' },
    { value: 'Afternoon', label: 'itineraries.experiences.form.time.afternoon' },
    { value: 'Evening', label: 'itineraries.experiences.form.time.evening' },
    { value: 'Night', label: 'itineraries.experiences.form.time.night' },
  ];

  experienceDTO = new ExperienceDTO();
  images: any = [];
  fileList: NzUploadFile[] = [];
  previewImage: string | undefined = "";
  previewVisible = false;

  // for the search
  listOfOption: any = [];
  selectedExperiences?: string;
  private searchToken = 0;

  radioValue = "";
  selectedKeywordIndex: number | undefined;
  type = "";
  isManualNew = false;
  tempExperiences: any = [];
  isImageExist?: boolean;
  effectiveDefaultImage: string = '';
  loading = false;

  contexts: any[] = [];
  title = "";
  selectedLanguages: any = [];
  languages: any = [];
  isDisplayAiButton = false;
  isCustom = false;
  notes = "";
  currentCountryBoxChecked = false;
  countyData: any;
  currencies: any[] = [];
  isPrimaryCurrency = true;
  isButtonLoading = false;
  toggleNotes = false;

  standaloneFileList: NzUploadFile[] = [];
  standaloneImages: any = [];

  // Add New Experience Modal state
  isAddExperienceModalVisible = false;
  addExpSearchName = "";
  addExpListOfOption: any = [];
  addExpIsDetailsExist = false;
  addExpLoading = false;
  addExpExperienceDTO: any = {};
  addExpGooglePlaceDetails: any;
  addExpActionMessage: ActionAlert = new ActionAlert();

  toggleCosting = false;
  toggleAdvancedOptions = false;
  costTypeOptions: any[] = [];

  protected readonly SETTINGS = SETTINGS;

  constructor(private fb: FormBuilder,
              private modal: NzModalRef,
              private message: NzMessageService,
               private itineraryService: ItineraryService,
               private itineraryTemplatesService: ItineraryTemplatesService,
               private googlePlacesService: GooglePlacesService,
              private uploadService: UploadService,
              private experienceService: ExperienceService,
              private settingService: SettingService,
              private languageService: LanguageService,
              private authService: AuthService,
              private openAiService: OpenAiService,
              public translocoService: TranslocoService,
              private userService: UserService) {

    this.formErrors = {
      body: {},
      keyword: {},
      keywordIndex: {},
      image: {},
      costPerAdult: {},
      costPerChild: {},
      costPerInfant: {},
      conditionType: {},
    };
  }




  private getCostTypeOptions(): Array<{ value: string; label: string }> {
    const lang = this.translocoService.getActiveLang();
    const f = SETTINGS.COST_TYPES_EXPERIENCES.filter(i => i.language === lang);
    return (f.length ? f : SETTINGS.COST_TYPES_EXPERIENCES.filter(i => i.language === 'en'))
      .map(({ value, label }) => ({ value, label }));
  }
  private getFixedPercentOptions(): Array<{ value: string; label: string; emoji: string }> {
    const lang = this.translocoService.getActiveLang();
    const filtered = SETTINGS.FIXED_PERCENT_SYMBOL.filter(item => item.language === lang);
    return (filtered.length ? filtered : SETTINGS.FIXED_PERCENT_SYMBOL.filter(item => item.language === 'en'))
      .map(({ value, label, emoji }) => ({ value, label, emoji }));
  }
  private getConditionTypeOptions(): Array<{ value: string; label: string }> {
    const lang = this.translocoService.getActiveLang();
    const filtered = SETTINGS.CONDITION_TYPES.filter(item => item.language === lang);
    return (filtered.length ? filtered : SETTINGS.CONDITION_TYPES.filter(item => item.language === 'en'))
      .map(({ value, label }) => ({ value, label }));
  }
  get activeService(): ItineraryService | ItineraryTemplatesService {
    return this.itineraryMode === 'template' ? this.itineraryTemplatesService : this.itineraryService;
  }

  ngOnInit(): void {
    this.addCurrency();
    this.fixedPercentSymbol = this.getFixedPercentOptions();
    this.costTypeOptions = this.getCostTypeOptions();
    this.conditionTypes = this.getConditionTypeOptions();
    this.langChangeSub = this.translocoService.langChanges$.subscribe(() => {
      this.fixedPercentSymbol = this.getFixedPercentOptions();
      this.costTypeOptions = this.getCostTypeOptions();
      this.conditionTypes = this.getConditionTypeOptions();
    });
    this.findBrand().then();
    this.getLanguages().then();

    if (SETTINGS.ITINERARY_CONTENT_MODE.EDIT === this.mode) {
      this.loading = true;
      this.googlePlacesService.experiencesExistGoogleDetails(this.experiencesPlaceIDOrID, this.entryType).then(value => {
        this.googlePlaceDetails = value;
        this.loading = false;
      });
      this.listOfTagOptions.push(...this.dateIndex);
    } else {
      this.listOfTagOptions.push(this.dateIndex);
    }

    this.experiencesForm = this.fb.group({
      isCustomTitle: [false],
      customTitle: [""],
      costPerAdult: [0, Validators.min(0)],
      costPerChild: [0 , Validators.min(0)],
      costPerInfant: [0, Validators.min(0)],
      conditionType: ['NA'],
      customUrl: ["", [Validators.pattern(SETTINGS.REGEX.URL.EXP)]],
      time: [null],
      costType: [this.costTypeOptions[1].value],
      advancedOptions: this.fb.group({
        isChecked: [false],
        includedPax: [0],
        extraPaxCost: [0],
      }),
      costing: this.fb.group({
        markupRatio: [0],
        markupSymbol: [SETTINGS.FIXED_PERCENT_SYMBOL_OBJECT.PERCENT],
        markup: [0],
        subTotal: [0],
        totalCost: [0],
        maximumPax: [0],
        quantity: [0],
        cost: [0],
      }),
    });

    // Recalculate whenever any costing-related field changes
    const costFields = ['costPerAdult', 'costPerChild', 'costPerInfant'];
    costFields.forEach(field => {
      this.experiencesForm.get(field)?.valueChanges.subscribe(() => this.recalculateCosting());
    });
    this.experiencesForm.get('costType')?.valueChanges.subscribe(() => this.recalculateCosting());
    this.experiencesForm.get('costing.markupRatio')?.valueChanges.subscribe(() => this.recalculateCosting());
    this.experiencesForm.get('costing.markupSymbol')?.valueChanges.subscribe(() => this.recalculateCosting());
    this.experiencesForm.get('costing.cost')?.valueChanges.subscribe(() => this.recalculateCosting());
    this.experiencesForm.get('costing.quantity')?.valueChanges.subscribe(() => this.recalculateCosting());
    this.experiencesForm.get('advancedOptions.includedPax')?.valueChanges.subscribe(() => this.recalculateCosting());
    this.experiencesForm.get('advancedOptions.extraPaxCost')?.valueChanges.subscribe(() => this.recalculateCosting());
    this.experiencesForm.get('advancedOptions.isChecked')?.valueChanges.subscribe((checked: boolean) => {
      const maximumPaxCtrl = this.experiencesForm.get('costing.maximumPax');
      const quantityCtrl = this.experiencesForm.get('costing.quantity');
      if (checked) {
        maximumPaxCtrl?.setValue(0, { emitEvent: false });
        quantityCtrl?.setValue(0, { emitEvent: false });
        maximumPaxCtrl?.disable({ emitEvent: false });
        quantityCtrl?.disable({ emitEvent: false });
      } else {
        maximumPaxCtrl?.enable({ emitEvent: false });
        quantityCtrl?.enable({ emitEvent: false });
      }
      this.recalculateCosting();
    });
    this.experiencesForm.get('costing.maximumPax')?.valueChanges.subscribe((maxPax: number) => {
      if (maxPax && maxPax > 0) {
        const pax = this.itinerary?.tour?.pax;
        const totalPax = (pax?.adults ?? 0) + (pax?.children ?? 0);
        const quantity = Math.ceil(totalPax / maxPax);
        this.experiencesForm.get('costing')?.patchValue({ quantity }, { emitEvent: false });
        this.recalculateCosting();
      }
    });

    this.featuredForm = this.fb.group({
      body: ["", []],
      keyword: ["", [Validators.required]],
      image: [""],
      keywordIndex: ["", [Validators.required]],
      imagePosition: [{ ...DEFAULT_IMAGE_POSITION }],
    });


    this.subscription = this.googlePlacesService.onFindPlaceDetailsChange.subscribe(async (data) => {
      if (data !== undefined) {
        if (data.exist === true) {
          this.type = "update";
          this.experienceDTO = data.experience;
          this.notes = this.featuredNote;
          this.images = this.experienceDTO.images;
          this.experienceDTO.contexts = this.getContexts(this.experienceDTO.contexts);
          this.contexts = this.experienceDTO.contexts;
          this.ensureTitleForLanguage(this.experienceDTO.titles, this.itinerary.tour.language);
          this.fileList = this.experienceDTO.images.map(
            (image: any, index: number) => ({
              uid: (index + 1).toString(),
              name: "image.png",
              status: "done",
              url: image,
            }));
          this.generateTempValues();
          this.filterContentByLanguage(this.itinerary.tour.language);
          await this.fetchEffectiveDefaultImage();
          this.standaloneImages = [];
          this.standaloneFileList = this.standaloneImages.map(
            (image: any, index: number) => ({
              uid: (index + 1).toString(),
              name: `image${index + 1}.png`,
              status: "done",
              url: image,
            }));
          this.onChangeImageUpload(this.standaloneFileList);

          if (SETTINGS.ITINERARY_CONTENT_MODE.EDIT === this.mode) {
            this.standaloneImages = this.tempExperiences[this.indexDay]?.experiencesPerDay[this.indexExperience]?.standaloneImages || [];
            const expEntry = this.itinerary.experiences[this.indexDay].experiencesPerDay[this.indexExperience];
            this.experiencesForm.patchValue({
              isCustomTitle: expEntry?.isCustomTitle,
              customTitle: expEntry?.customTitle,
              costPerAdult: expEntry?.costPerAdult,
              costPerChild: expEntry?.costPerChild,
              costPerInfant: expEntry?.costPerInfant,
              customUrl: expEntry?.customUrl || this.experienceDTO?.url || "",
              time: expEntry?.time || null,
              conditionType: expEntry?.conditionType || this.experienceDTO?.conditionType,
              costType: expEntry?.costType ?? this.costTypeOptions[1].value,
              advancedOptions: {
                isChecked: expEntry?.advancedOptions?.isChecked ?? false,
                includedPax: expEntry?.advancedOptions?.includedPax ?? 0,
                extraPaxCost: expEntry?.advancedOptions?.extraPaxCost ?? 0,
              },
              costing: {
                markupRatio: expEntry?.costing?.markupRatio ?? 0,
                markupSymbol: expEntry?.costing?.markupSymbol ?? SETTINGS.FIXED_PERCENT_SYMBOL_OBJECT.PERCENT,
                markup: expEntry?.costing?.markup ?? 0,
                subTotal: expEntry?.costing?.subTotal ?? 0,
                totalCost: expEntry?.costing?.totalCost ?? 0,
                maximumPax: expEntry?.costing?.maximumPax ?? 0,
                quantity: expEntry?.costing?.quantity ?? 0,
                cost: expEntry?.costing?.cost ?? 0,
              },
            });
            this.recalculateCosting();

            this.isPrimaryCurrency = this.itinerary.experiences[this.indexDay].experiencesPerDay[this.indexExperience]?.isPrimaryCurrency;
            const isMatch = this.contexts.some(ctx => ctx.body === this.featuredContent.body);
            if (isMatch) {
              this.featuredForm.patchValue({
                body: this.featuredContent !== null ? this.featuredContent.body : this.contexts[0].body,
                keyword: this.featuredContent !== null ? this.featuredContent?.keyword || this.contexts[0].keyword : this.contexts[0].keyword,
                language: this.featuredContent !== null ? this.itinerary.tour.language || this.contexts[0].language : this.contexts[0].language,
                image: this.featuredContent?.image || this.getEffectiveDefaultImage(),
                keywordIndex: "0",
                imagePosition: this.featuredContent?.imagePosition ?? { ...DEFAULT_IMAGE_POSITION },
              });
            }else{
              this.featuredForm.patchValue({
                body: this.contexts[0].body,
                keyword:  this.contexts[0].keyword,
                language:  this.contexts[0].language,
                image: this.featuredContent?.image || this.getEffectiveDefaultImage(),
                keywordIndex: "0",
                imagePosition: { ...DEFAULT_IMAGE_POSITION },
              });
            }
          } else{
            this.experiencesForm.patchValue({
              customUrl: this.experienceDTO?.url || "",
              conditionType: this.experienceDTO?.conditionType || 'OPT',
            });
            this.featuredForm.patchValue({
              body: this.featuredContent !== null ? this.featuredContent.body : this.contexts[0].body,
              keyword: this.featuredContent !== null ? this.featuredContent?.keyword || this.contexts[0].keyword : this.contexts[0].keyword,
              language: this.featuredContent !== null ? this.itinerary.tour.language || this.contexts[0].language : this.contexts[0].language,
              image: this.featuredContent?.image || this.getEffectiveDefaultImage(),
              keywordIndex: "0",
              imagePosition: this.featuredContent?.imagePosition ?? { ...DEFAULT_IMAGE_POSITION },
            });
          }

          this.radioValue = "0";
          this.selectedKeywordIndex = this.findExperienceContextsIndex(this.contexts[0].body);

        } else if (data.exist === false) {
          this.isDisplayAiButton = true;
          this.notes = this.featuredNote;
          this.type = "new";
          this.fileList = [];
          this.images = [];
          this.title = this.tempSuggestion.structuredFormat.mainText.text;
          this.experienceDTO.contexts = [];
          this.experienceDTO.titles = this.generateTitles(this.title, 1);
          this.experienceDTO.location = data.location;
          this.experienceDTO.apiId = data.id;
          this.experienceDTO.active = true;
          this.experienceDTO.images = [];
          this.experienceDTO.contexts.push(this.contextInit());

          this.filterContentByLanguage(this.itinerary.tour.language);
          this.featuredForm.patchValue({
            body: this.contexts[0].body,
            keyword: this.contexts[0].keyword,
            language: this.contexts[0].language,
            image: "",
            keywordIndex: "0",
            imagePosition: { ...DEFAULT_IMAGE_POSITION },
          });
          this.radioValue = "0";
          this.selectedKeywordIndex = 0;
          this.generateTempValues();

          this.standaloneImages = [];
          this.standaloneFileList = this.standaloneImages.map(
            (image: any, index: number) => ({
              uid: (index + 1).toString(),
              name: `image${index + 1}.png`,
              status: "done",
              url: image,
            }));
          this.onChangeImageUpload(this.standaloneFileList);
        }
      }
    });

    this.experiencesForm.valueChanges.subscribe((form: any) => {
      if (form?.isCustomTitle === true) {
        this.experiencesForm.get('customTitle').addValidators(Validators.required);
        this.experiencesForm.updateValueAndValidity();
      }else{
        this.experiencesForm.get('customTitle').clearValidators();
        this.experiencesForm.updateValueAndValidity();
      }
      this.formErrors = AppUtils.getFormErrors(this.experiencesForm, this.formErrors);
    });

    this.featuredForm.valueChanges.subscribe((form: any) => {
      if (this.selectedKeywordIndex !== undefined) {
        this.experienceDTO.contexts[this.selectedKeywordIndex].body = form?.body;
      }
      this.formErrors = AppUtils.getFormErrors(this.featuredForm, this.formErrors);
    });

    this.featuredForm.get("body")?.valueChanges.subscribe( (value: any) => {
      if (this.featuredForm.get("body")?.dirty) {
        this.isCustom = true;
      }
    });

    this.uploadService.onUploadedFileChange.subscribe(value => {
      this.loading = false;
    });
  }

  search(value: string): void {
    const token = ++this.searchToken;
    if (value !== "") {
      const payload = this.getPayload(this.currentCountryBoxChecked, value);
      this.googlePlacesService.postAutoComplete({
        ...payload,
      }).then(res => {
        if (token !== this.searchToken) return;
        this.listOfOption = res?.suggestions || [];
        this.listOfOption.push(this.manualExperienceDataInit(value));
      });

      this.experienceService.getExperiencesByName({name: value}).then(res => {
        if (token !== this.searchToken) return;
        this.listOfOption = [...this.listOfOption, ...res];
      });
      this.experienceService.getExperiencesByTitle({titleName: value, language: this.itinerary.tour.language}).then(res => {
        if (token !== this.searchToken) return;
        this.listOfOption = [...this.listOfOption, ...res];
      });
    }else{
      this.listOfOption = [];
    }
  }

  handleCancel(): void {
    this.modal.close();
  }

  openAddExperienceModal(): void {
    this.resetNewExperience();
    this.isAddExperienceModalVisible = true;
  }

  closeAddExperienceModal(): void {
    this.isAddExperienceModalVisible = false;
    this.resetNewExperience();
  }

  searchNewExperience(value: string): void {
    if (value !== "") {
      this.googlePlacesService.postAutoComplete({
        input: value,
        primaryTypes: []
      }).then(res => {
        this.addExpListOfOption = res?.suggestions || [];
        this.addExpListOfOption.push(this.manualExperienceDataInit(value));
      });
    }
  }

  async selectedNewExperienceResult(data: any): Promise<any> {
    this.addExpActionMessage = new ActionAlert();
    try {
      this.addExpLoading = true;
      if (data?.placeId) {
        this.addExpGooglePlaceDetails = await this.googlePlacesService.getPlaceDetails(data.placeId);
        const genTitles = this.generateTitles(data.structuredFormat.mainText.text, 1);
        this.addExpIsDetailsExist = true;
        this.addExpExperienceDTO = {
          titles: genTitles,
          name: data.structuredFormat.mainText.text,
          area: data.structuredFormat?.secondaryText?.text || "",
          location: this.addExpGooglePlaceDetails?.location,
          apiId: data.placeId,
          active: true,
          entryType: SETTINGS.ENTRY_TYPES.GOOGLE,
          cost: 0,
          notes: ""
        };
      } else {
        // Manual entry
        const genTitles = this.generateTitles(data.structuredFormat.mainText.text, 1);
        this.addExpIsDetailsExist = true;
        this.addExpExperienceDTO = {
          titles: genTitles,
          name: data.structuredFormat.mainText.text,
          area: "",
          location: "",
          apiId: "",
          active: true,
          entryType: SETTINGS.ENTRY_TYPES.MANUAL,
          cost: 0,
          notes: ""
        };
      }
      this.addExpLoading = false;
    } catch (e) {
      this.addExpLoading = false;
      this.message.error(this.translocoService.translate('itineraries.experiences.messages.fetchDetailsError'));
    }
  }

  async addNewExperience(): Promise<any> {
    this.addExpLoading = true;
    try {
      await this.experienceService.createExperience({...this.addExpExperienceDTO});
      this.addExpActionMessage = new ActionAlert(
        true,
        true,
        this.translocoService.translate('itineraries.experiences.messages.addSuccess'),
        "success"
      );
      this.addExpLoading = false;
      this.resetNewExperience();
    } catch (error: any) {
      this.addExpActionMessage = new ActionAlert(
        true,
        true,
        error?.error?.message || this.translocoService.translate('itineraries.experiences.messages.addFailed'),
        "error"
      );
      this.addExpLoading = false;
    }
  }

  resetNewExperience(): void {
    this.isAddExperienceModalVisible = false;
    this.addExpSearchName = "";
    this.addExpListOfOption = [];
    this.addExpIsDetailsExist = false;
    this.addExpExperienceDTO = {};
    this.addExpGooglePlaceDetails = undefined;
    this.addExpActionMessage = new ActionAlert();
  }

  private manualExperienceDataInit(name: string): any {
    return {
      placePrediction: {
        text: {text: name},
        placeId: "",
        structuredFormat: {
          mainText: {text: name}
        },
        entry: "manual"
      }
    };
  }

  setMediaUploadHeaders = (file: any) => {
    return {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
    };
  }

  onRemove = (item: NzUploadXHRArgs | any) => {
    this.removeUploadImage(item.url);
    return true;
  }

  handlePreview = async (file: NzUploadFile | any): Promise<void> => {
    if (!file.url && !file.preview) {
      // tslint:disable-next-line:no-non-null-assertion
      file.preview = await getBase64(file.originFileObj!);
    }
    this.previewImage = file.url || file.preview;
    this.previewVisible = true;
  }

  handleChange(event: NzUploadChangeParam): any {
    const url = event?.file?.response?.url;
    if (event?.type === "success" && url) {
      this.addUploadImage(url);
      this.featuredForm.patchValue({image: url});
      this.syncUploadFileList();
    }
  }

  customUploadReq = (item: NzUploadXHRArgs | any) => {
    this.loading = true;
    const formData = new FormData();
    formData.append("file", item.file);
    return this.uploadService.uploadFile(formData, item);
  }


  async selectedExperience(data: any): Promise<any> {
    // "entry" property marks the create-new option injected by search()
    if (data?.entry !== undefined) {
      this.initCreateNewExperience(data);
      return;
    }
    try {
      this.tempSuggestion = data;
      if (data.entryType === SETTINGS.ENTRY_TYPES.MANUAL) {
        this.googlePlaceDetails = await this.googlePlacesService.experiencesExistGoogleDetails(data.experiencesId,
          SETTINGS.ENTRY_TYPES.MANUAL);
      } else {
        this.googlePlaceDetails = await this.googlePlacesService.experiencesExistGoogleDetails(data.placeId, SETTINGS.ENTRY_TYPES.GOOGLE);
      }

    } catch (e) {
      console.log(e);
      this.message.error(this.translocoService.translate('itineraries.experiences.messages.somethingWentWrong'));
    }
  }

  initCreateNewExperience(data: any): void {
    const name = data.structuredFormat.mainText.text;
    this.isDisplayAiButton = true;
    this.notes = this.featuredNote;
    this.type = "new";
    this.isManualNew = true;
    this.fileList = [];
    this.images = [];
    this.title = name;
    this.tempSuggestion = data;
    this.experienceDTO = new ExperienceDTO();
    this.experienceDTO.contexts = [];
    this.experienceDTO.titles = this.generateTitles(name, 1);
    this.experienceDTO.location = null;
    this.experienceDTO.apiId = "";
    this.experienceDTO.active = true;
    this.experienceDTO.contexts.push(this.contextInit());

    this.filterContentByLanguage(this.itinerary.tour.language);
    this.featuredForm.patchValue({
      body: this.contexts[0].body,
      keyword: this.contexts[0].keyword,
      language: this.contexts[0].language,
      image: "",
      keywordIndex: "0",
      imagePosition: { ...DEFAULT_IMAGE_POSITION },
    });
    this.radioValue = "0";
    this.selectedKeywordIndex = 0;
    this.generateTempValues();

    this.standaloneImages = [];
    this.standaloneFileList = [];
    this.onChangeImageUpload(this.standaloneFileList);
  }

  getSelectedImage(): any {
    return this.featuredForm.controls.image.value;
  }

  selectedKeyword(tempBody: any): void {
    // find the index of experienceDTO.contexts
    this.selectedKeywordIndex = this.findExperienceContextsIndex(tempBody);
    this.featuredForm.patchValue({
      body: tempBody,
      keyword: this.featuredForm.controls.keyword.value,
      keywordIndex: this.selectedKeywordIndex,
      language: this.itinerary.tour.language,
    });
  }

  async addExperiences(): Promise<any> {
    this.isButtonLoading = true;
    this.recalculateCosting();
    try {
      if (this.type === "new") {
        const images = this.getNewExperienceImages();
        const defaultImage = this.featuredForm.get('image')?.value || images[0] || '';
        const payload = this.isManualNew ? {
          name: this.tempSuggestion.structuredFormat.mainText.text,
          area: "",
          titles: this.experienceDTO.titles,
          location: null,
          apiId: "",
          contexts: this.experienceDTO.contexts,
          images,
          defaultImage,
          active: true,
          entryType: SETTINGS.ENTRY_TYPES.MANUAL,
          url: this.experiencesForm.get('customUrl').value,
        } : {
          name: this.tempSuggestion.structuredFormat.mainText.text,
          area: this.tempSuggestion.structuredFormat.secondaryText?.text || "",
          titles: this.experienceDTO.titles,
          location: this.googlePlaceDetails.location,
          apiId: this.tempSuggestion.placeId,
          contexts: this.experienceDTO.contexts,
          images,
          defaultImage,
          active: true,
          entryType: SETTINGS.ENTRY_TYPES.GOOGLE,
          url: this.experiencesForm.get('customUrl').value,
        };

        await this.experienceService.createExperienceModal(payload).then(res => {
          this.tempExperiences.map((day: any, index: any) => {
            if (this.listOfTagOptions.includes(index)) {
              this.tempExperiences[index].experiencesPerDay.push(
                {experience: res._id,
                  notes: this.notes,
                  ...this.experiencesForm.getRawValue(),
                  isPrimaryCurrency : this.isPrimaryCurrency,
                  featuredExperience: this.featuredForm.getRawValue(),
                  standaloneImages: []
                }
              );
            }
          });
        });

        await this.activeService.updateItineraryLockState(withItineraryLockSession({_id: this.itinerary._id, experiences: this.tempExperiences}, this.sessionId!));
        const itinerary: any = await this.activeService.getItineraryById({id: this.itinerary._id});
        const generatedRich = await this.getRichText(itinerary);
        const IncExcRichText: any = { ...itinerary.itinerary, ...generatedRich};
        await this.activeService.updateItineraryLockState(withItineraryLockSession({_id: this.itinerary._id, itinerary: IncExcRichText}, this.sessionId!));
        this.isManualNew = false;
        this.isButtonLoading = false;
        this.modal.close(SETTINGS.ITINERARY_MESSAGE_STATUS.ADD_SUCCESS);

      } else {

        if (SETTINGS.ITINERARY_CONTENT_MODE.EDIT === this.mode) {
          const featureFormValue = this.featuredForm.getRawValue();
          if (featureFormValue.keyword === "Custom") {
            this.isCustom = true;
          }

          const originalExperienceId = this.itinerary.experiences[this.indexDay].experiencesPerDay[this.indexExperience].experience._id;
          const originalDays: number[] = this.dateIndex; // days the experience was originally on
          const newDays: number[] = this.listOfTagOptions; // days the user has now selected

          const updatedEntry = {
            experience: this.experienceDTO._id,
            notes: this.notes,
            ...this.experiencesForm.getRawValue(),
            isPrimaryCurrency: this.isPrimaryCurrency,
            standaloneImages: this.standaloneImages ? this.standaloneImages : [],
            featuredExperience: {
              isCustom: this.isCustom,
              ...featureFormValue,
              keyword: this.isCustom ? "Custom" : featureFormValue.keyword
            }
          };

          for (let i = 0; i < this.tempExperiences.length; i++) {
            const wasOnThisDay = originalDays.includes(i);
            const shouldBeOnThisDay = newDays.includes(i);

            if (wasOnThisDay && shouldBeOnThisDay) {
              // Update in place on this day
              const idx = this.tempExperiences[i].experiencesPerDay.findIndex(
                (ep: any) => ep.experience === originalExperienceId
              );
              if (idx !== -1) {
                this.tempExperiences[i].experiencesPerDay[idx] = updatedEntry;
              }
            } else if (wasOnThisDay && !shouldBeOnThisDay) {
              // Remove from this day
              this.tempExperiences[i].experiencesPerDay = this.tempExperiences[i].experiencesPerDay.filter(
                (ep: any) => ep.experience !== originalExperienceId
              );
            } else if (!wasOnThisDay && shouldBeOnThisDay) {
              // Add to this new day
              this.tempExperiences[i].experiencesPerDay.push(updatedEntry);
            }
          }

          const {contexts, ...rest} = this.experienceDTO;
          await this.experienceService.updateExperienceItin(rest);
          await this.activeService.updateItineraryLockState(withItineraryLockSession({_id: this.itinerary._id, experiences: this.tempExperiences}, this.sessionId!));
          const itinerary: any = await this.activeService.getItineraryById({id: this.itinerary._id});
          const generatedRich = await this.getRichText(itinerary);
          const IncExcRichText: any = { ...itinerary.itinerary, ...generatedRich};
          await this.activeService.updateItineraryLockState(withItineraryLockSession({_id: this.itinerary._id, itinerary: IncExcRichText}, this.sessionId!));
          this.isButtonLoading = false;
          this.modal.close(SETTINGS.ITINERARY_MESSAGE_STATUS.EDIT_SUCCESS);

        } else {
          const featureFormValue = this.featuredForm.getRawValue();
          if (featureFormValue.keyword === "Custom") {
            this.isCustom = true;
          }

          this.tempExperiences.map((day: any, index: any) => {
            if (this.listOfTagOptions.includes(index)) {
              this.tempExperiences[index].experiencesPerDay.push(
                {
                  experience: this.experienceDTO._id,
                  notes: this.notes,
                  ...this.experiencesForm.getRawValue(),
                  isPrimaryCurrency : this.isPrimaryCurrency,
                  standaloneImages: this.standaloneImages ? this.standaloneImages : [],
                  featuredExperience: {
                    isCustom: this.isCustom,
                    ...featureFormValue,
                    keyword: this.isCustom ? "Custom" : featureFormValue.keyword
                  }
                }
              );
            }
          });
          const {contexts, ...rest} = this.experienceDTO;
          await this.experienceService.updateExperienceItin(rest);
          await this.activeService.updateItineraryLockState(withItineraryLockSession({_id: this.itinerary._id, experiences: this.tempExperiences}, this.sessionId!));
          const itinerary: any = await this.activeService.getItineraryById({id: this.itinerary._id});
          const generatedRich = await this.getRichText(itinerary);
          const IncExcRichText: any = { ...itinerary.itinerary, ...generatedRich};
          await this.activeService.updateItineraryLockState(withItineraryLockSession({_id: this.itinerary._id, itinerary: IncExcRichText}, this.sessionId!));
          this.isButtonLoading = false;
          this.modal.close(SETTINGS.ITINERARY_MESSAGE_STATUS.EDIT_SUCCESS);

        }
      }
    } catch (e) {
      this.isButtonLoading = false;
      console.log(e);
      this.modal.close(SETTINGS.ITINERARY_MESSAGE_STATUS.ERROR);
    }
  }

  onChangeImageUpload(file: any): void {
    if (file.length >= 1) {
      this.isImageExist = true;
    } else if (file.length === 0) {
      this.isImageExist = false;
    }
  }

  getUploadImages(): string[] {
    return this.type === "new" ? this.images : this.standaloneImages;
  }

  private addUploadImage(url: string): void {
    if (this.type === "new") {
      if (!this.images.includes(url)) {
        this.images.push(url);
      }
      this.experienceDTO.images = [...this.images];
      return;
    }
    if (!this.standaloneImages.includes(url)) {
      this.standaloneImages.push(url);
    }
  }

  private removeUploadImage(url: string): void {
    if (this.type === "new") {
      this.images = this.images.filter((x: string) => x !== url);
      this.experienceDTO.images = [...this.images];
      return;
    }
    this.standaloneImages = this.standaloneImages.filter((x: string) => x !== url);
  }

  private syncUploadFileList(): void {
    const source = this.getUploadImages();
    const mapped = source.map((image: string, index: number) => ({
      uid: (index + 1).toString(),
      name: `image${index + 1}.png`,
      status: "done" as const,
      url: image,
    }));
    if (this.type === "new") {
      this.fileList = mapped;
    } else {
      this.standaloneFileList = mapped;
    }
    this.onChangeImageUpload(mapped);
  }

  private getNewExperienceImages(): string[] {
    return [...new Set((this.experienceDTO?.images || []).filter(Boolean))];
  }


  async findBrand(): Promise<any> {
    const user = await this.authService.getLoggedInUser();
    const brand = await this.settingService.findBrand(user.userId);
    this.selectedLanguages = brand?.selectedLanguages || [];
  }

  async getLanguages(): Promise<any> {
    this.languages = await this.languageService.getContentLanguages();
  }

  filterContentByLanguage(lang: string): void {
    this.title = this.experienceDTO.titles
      .filter(obj => obj.language === lang)
      .map(obj => obj.name)
      .join(", ");
    this.contexts = this.experienceDTO.contexts
      .filter(obj => obj.language === lang);

    // Context don't exist, by default context will be added to local variable and dto
    if (this.contexts.length === 0) {
      this.isDisplayAiButton = true;
      this.contexts.push(this.contextInit());
      this.experienceDTO.contexts.push(this.contextInit());
    }
  }

  generateTitles(tempName?: string, toggle?: number): any {
    if (toggle === 1) {
      return this.selectedLanguages.map((languageCode: any) => {
        return {name: tempName, language: languageCode};
      });
    }

    if (toggle === 2) {
      return this.selectedLanguages.map((languageCode: any, index: number) => {
        return {name: this.experienceDTO.titles[index].name, language: languageCode};
      });
    }

  }

  contextInit(): any {
    return {
      keyword: this.translocoService.translate('itineraries.experiences.form.defaultKeyword'),
      body: this.translocoService.translate('itineraries.experiences.form.defaultBody'),
      type: SETTINGS.CONTENT_TYPES.TYPED,
      language: this.itinerary.tour.language,
    };
  }

  findExperienceContextsIndex(tempBody: string): number {
    return this.experienceDTO.contexts.findIndex(
      (context) => context.body === tempBody && context.keyword === this.featuredForm.controls.keyword.value
    );
  }

  featuredInit(): any {
    return {
      body: "",
      keyword: "",
      image: "",
      keywordIndex: "0",
      imagePosition: { ...DEFAULT_IMAGE_POSITION },
    };
  }

  get currentImagePosition(): ImagePositionState {
    return this.featuredForm.get('imagePosition')?.value ?? { ...DEFAULT_IMAGE_POSITION };
  }

  onImagePositionChange(state: ImagePositionState): void {
    this.featuredForm.patchValue({ imagePosition: state }, { emitEvent: false });
  }

  async getGeneratedContent(queryData: any): Promise<void> {
    this.loading = true;
    const payload = `Generate a captivating description of '${queryData.name}'between 40-60 words in '${queryData.language}'. starting with a unique word that has not been used before. Highlight key aspects that make the experience memorable and enticing.
        Provide only one tag describes the best for the generated content Tag should start with # and tag should be in english no matter what language it is.`;
    try {
      const value = await this.openAiService.askChatGPT({query: payload});
      this.breakdownAndPatchContent(value.choices[0].message.content);
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }

  private breakdownAndPatchContent(text: string): void {
    // breakdown the spaces
    const lines = text.split("\n");

    const contentLines: string[] = [];
    const tags: string[] = [];

    // Loop through each line
    lines.forEach(line => {
      const trimmedLine = line.trim();
      if (trimmedLine.startsWith("#")) {
        // Split by whitespace to handle multiple tags separated by spaces
        const lineTags = trimmedLine.split(/\s+/).map(tag => tag.substring(1));
        tags.push(...lineTags);
      } else {
        contentLines.push(line);
      }
    });

    // Join content lines into a single string
    const content = contentLines.join(" ").trim();

    // Join tags array into a comma-separated string
    const tagsString = tags.join(", ");

    this.featuredForm.patchValue({body: content, keyword: tagsString});
    this.contexts[0] = {
      body: content,
      keyword: tagsString,
      language: this.contexts[0].language,
      image: this.contexts[0].image,
      keywordIndex: this.contexts[0].keywordIndex,
    };

    this.experienceDTO.contexts[0] = this.contexts[0];
  }

  private getEffectiveDefaultImage(): string {
    return this.effectiveDefaultImage || this.experienceDTO?.defaultImage || this.images?.[0] || '';
  }

  private async fetchEffectiveDefaultImage(): Promise<void> {
    if (!this.experienceDTO?._id) {
      this.effectiveDefaultImage = this.experienceDTO?.defaultImage || this.images?.[0] || '';
      return;
    }
    try {
      const pref = await this.userService.getContentImagePreference('experiences', this.experienceDTO._id);
      this.effectiveDefaultImage = pref?.imageUrl || this.experienceDTO?.defaultImage || this.images?.[0] || '';
    } catch {
      this.effectiveDefaultImage = this.experienceDTO?.defaultImage || this.images?.[0] || '';
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.langChangeSub?.unsubscribe();
  }

  deleteImage(img: any): void {
    this.removeUploadImage(img);
    if (this.getUploadImages().length === 0) {
      this.featuredForm.patchValue({image: ""});
      this.isImageExist = false;
    }
  }
  cancel(): void {
  }
  removeSelectedImage(): void {
    this.featuredForm.controls.image.value = ""
  }

  getContexts(mainContexts: any[]): any[] {
    const contexts = [...mainContexts];
    if (this.mode === SETTINGS.ITINERARY_CONTENT_MODE.EDIT) {
      if (this.featuredContent?.keyword === "Custom"){
        contexts.push(
          {
            keyword: this.featuredContent.keyword,
            body: this.featuredContent.body,
            language: this.itinerary.tour.language,
            type: "typed"
          }
        );

        return contexts;
      }
    }

    return contexts;
  }

  onChangeCurrentCountry(value: any): void {
    this.currentCountryBoxChecked = value;

    if (this.currentCountryBoxChecked) {
      this.loading = true;
      this.getCurrentLocation().then(r => {
        this.countyData = r;
        this.loading = false;
      });
    }
  }

  async getCurrentLocation(): Promise<any> {
    try {
      return await this.googlePlacesService.postTextSearch({
        text: this.country
      });
    } catch (e) {
      this.message.error(this.translocoService.translate('itineraries.experiences.messages.countrySearchNotWorking'));
    }
  }

  getPayload(isRestrict: boolean, value: string): any {
    if (isRestrict && this.countyData) {
      return {
        input: value,
        locationRestriction: {
          rectangle: {
            high: {
              latitude: this.countyData?.viewport?.high.latitude,
              longitude: this.countyData?.viewport?.high.longitude
            },
            low: {
              latitude: this.countyData?.viewport?.low.latitude,
              longitude: this.countyData?.viewport?.low.longitude
            }
          }
        },
        primaryTypes: []
      };
    } else {
      return {
        input: value,
        primaryTypes: []
      };
    }
  }
  addCurrency(): void {
    if (this.itinerary?.tour?.currency) {
      this.currencies.push({label: this.itinerary?.tour?.currency, value: true});
    }

    if (this.itinerary?.tour?.secondaryCurrency !== ""){
      this.currencies.push({label: this.itinerary?.tour?.secondaryCurrency, value: false});
    }
  }

  generateTempValues(): void {
    this.tempExperiences = this.itinerary.experiences.map((day: any) => {
      const updatedExperiencesPerDay = day.experiencesPerDay
        .filter((experience: any) => experience.experience !== undefined)
        .map((experience: any) => ({
          experience: experience.experience._id,
          featuredExperience: experience.featuredExperience,
          notes: this.notes,
          isPrimaryCurrency: experience?.isPrimaryCurrency,
          isCustomTitle: experience?.isCustomTitle,
          customTitle: experience?.customTitle,
          costPerAdult: experience?.costPerAdult,
          costPerChild: experience?.costPerChild,
          costPerInfant: experience?.costPerInfant,
          conditionType: experience?.conditionType,
          customUrl: experience?.customUrl || "",
          time: experience?.time || null,
          standaloneImages: experience?.standaloneImages || [],
          costType: experience?.costType ?? this.costTypeOptions[1].value,
          advancedOptions: {
            isChecked: experience?.advancedOptions?.isChecked ?? false,
            includedPax: experience?.advancedOptions?.includedPax ?? 0,
            extraPaxCost: experience?.advancedOptions?.extraPaxCost ?? 0,
          },
          costing: {
            markupRatio: experience?.costing?.markupRatio ?? 0,
            markupSymbol: experience?.costing?.markupSymbol ?? SETTINGS.FIXED_PERCENT_SYMBOL_OBJECT.PERCENT,
            markup: experience?.costing?.markup ?? 0,
            subTotal: experience?.costing?.subTotal ?? 0,
            totalCost: experience?.costing?.totalCost ?? 0,
            maximumPax: experience?.costing?.maximumPax ?? 0,
            quantity: experience?.costing?.quantity ?? 0,
            cost: experience?.costing?.cost ?? 0,
          },
        }));
      return {...day, experiencesPerDay: updatedExperiencesPerDay};
    });
  }

  ensureTitleForLanguage(
    titles: { name: string; language: string; _id?: any }[],
    language: string,
  ): void {
    const exists = titles.some(title => title.language === language);
    if (!exists) {
      this.experienceDTO.titles.push({ name: this.experienceDTO.name, language });
    }
  }

  getIcon(data: any): string {
    if (data?.isQueried){
      return  "text-select";
    }else{
      return  data.placeId !== "" ? "globe" : "blocks";
    }
  }

  getRichText(itinerary: any): any {
      let includedRichText = stripExperienceBlocks(itinerary.itinerary.inclusions);
      let excludedRichText = stripExperienceBlocks(itinerary.itinerary.exclusions);
      includedRichText = appendRichText(includedRichText, SETTINGS.RICH_TEXTS.INCLUDED_RICH);
      excludedRichText = appendRichText(excludedRichText, SETTINGS.RICH_TEXTS.EXCLUDED_RICH);
      // included
      for (const element of itinerary.experiences) {
        const items = element.experiencesPerDay.filter((x: any) => x.conditionType === 'INC');
        const generateRichText = buildRichText(items);
        includedRichText = appendRichText(includedRichText, generateRichText);
      }

      // excluded
      for (const element of itinerary.experiences) {
        const items = element.experiencesPerDay.filter((x: any) => x.conditionType === 'EXC');
        const generateRichText = buildRichText(items);
        excludedRichText = appendRichText(excludedRichText, generateRichText);
      }

      includedRichText = appendRichText(includedRichText, SETTINGS.RICH_TEXTS.END_RICH);
      excludedRichText = appendRichText(excludedRichText, SETTINGS.RICH_TEXTS.END_RICH);

      return {inclusions: includedRichText, exclusions: excludedRichText};
  }

  getConditionClass(condValue: string): any {
    const selected = this.experiencesForm.get("conditionType")?.value;

    return {
      "na-selected-excluded": condValue === "EXC" && selected === "EXC",
      "na-selected-included": condValue === "INC" && selected === "INC"
    };
  }

  formatter = currencyFormatter;
  parser = amountParser;

  getSubTotal(): number {
    const costType = this.experiencesForm.get('costType')?.value;

    if (costType === 'free') {
      return 0;
    }

    if (costType === 'perPerson') {
      const pax = this.itinerary?.tour?.pax;
      const costPerAdult = this.experiencesForm.get('costPerAdult')?.value ?? 0;
      const costPerChild = this.experiencesForm.get('costPerChild')?.value ?? 0;
      const costPerInfant = this.experiencesForm.get('costPerInfant')?.value ?? 0;
      return (costPerAdult * (pax?.adults ?? 0)) +
             (costPerChild * (pax?.children ?? 0)) +
             (costPerInfant * (pax?.infants ?? 0));
    }

    if (costType === 'perGroup') {
      const cost = this.experiencesForm.get('costing.cost')?.value ?? 0;
      const quantity = this.experiencesForm.get('costing.quantity')?.value ?? 0;
      const includedPax = this.experiencesForm.get('advancedOptions.includedPax')?.value ?? 0;
      const extraPaxCost = this.experiencesForm.get('advancedOptions.extraPaxCost')?.value ?? 0;
      const isChecked = this.experiencesForm.get('advancedOptions.isChecked')?.value ?? false;

      if (isChecked) {
        const pax = this.itinerary?.tour?.pax;
        const totalPax = (pax?.adults ?? 0) + (pax?.children ?? 0);
        const extraPax = Math.max(0, totalPax - includedPax);
        return cost + (extraPax * extraPaxCost);
      }

      return (cost * quantity);
    }

    return 0;
  }

  getMarkup(): number {
    const costType = this.experiencesForm.get('costType')?.value;
    if (costType === 'free') return 0;

    const subTotal = this.getSubTotal();
    const markupRatio = this.experiencesForm.get('costing.markupRatio')?.value ?? 0;
    const markupSymbol = this.experiencesForm.get('costing.markupSymbol')?.value;
    if (markupSymbol === SETTINGS.FIXED_PERCENT_SYMBOL_OBJECT.PERCENT) {
      return subTotal * markupRatio / 100;
    }
    return markupRatio;
  }

  getTotalCost(): number {
    const costType = this.experiencesForm.get('costType')?.value;
    if (costType === 'free') return 0;
    return this.getSubTotal() + this.getMarkup();
  }

  recalculateCosting(): void {
    const costing = this.experiencesForm.get('costing');
    costing?.patchValue({
      subTotal: this.getSubTotal(),
      markup: this.getMarkup(),
      totalCost: this.getTotalCost(),
    }, { emitEvent: false });
  }
}
